const AlphaAtlasValidationEvidenceWarning = () => (
    <p className="rounded border border-amber-700/70 bg-amber-950/30 p-4 text-sm text-amber-200">
        Validation is historical, survivor-biased, exploratory, and never promotable. Candidate selection is frozen before verification is
        revealed. A campaign with K=0 is a valid scientific result and must not trigger policy tuning against verification evidence.
    </p>
);

export default AlphaAtlasValidationEvidenceWarning;
